import React, { Component } from 'react';
import axios from 'axios';
import {path} from './routes.js';
import SelectBox from '../component/Select.js';
import Input from '../component/Input.js';
import ViewASMOrders from './ViewASMOrders.js'; //component that contains all order information to be viewed
import Modal from 'react-modal';
import TableHead from '../component/TableHead.js';
import settingsGear from '../asset/img/settingsGear.png';
import loader from '../asset/img/loader.gif';

export default class ASMRegionalCenter extends Component {
	constructor(props){
		super(props);
		this.handleSelection = this.handleSelection.bind(this);
		this.handleBudget = this.handleBudget.bind(this);
		this.handleAnnualBudget = this.handleAnnualBudget.bind(this);
		this.individualAnnualBudget = this.individualAnnualBudget.bind(this);
		this.setAnnualBudgets = this.setAnnualBudgets.bind(this);
		this.getAnnualBudgets = this.getAnnualBudgets.bind(this);
		this.onSave = this.onSave.bind(this);
		this.departmentInfo = this.departmentInfo.bind(this);
		this.openModal = this.openModal.bind(this);
		this.closeModal = this.closeModal.bind(this);
		this.hoverTab = this.hoverTab.bind(this);
		this.state = {
						threshold:0,
						approval:'',
						current:'',
						modalIsOpen:false,
						loading:false,
						saved:false,
						NSD:false,
						departmentInfo:[],
						updateInfo:[],
						currentDepartmentInfo:[],
						initialBudget:0,
						remainingBudget:0,
						spent:0,
						initialAllocated:0,
						allocated:0,
						regionalID:0,
						department:'',
						departmentNames:[],
						annualBudgetInfo:[],
						annualBudgetUpdate:[],
						individualAnnualBudgetUpdate:[],
						modalPrompt:'',
						modalView:'departments'
					};
	}

	componentDidMount(){ //when component mounts, grab their settings
		if(this.props.userInfo.userType !== 'asm'){
			this.departmentInfo();
		}
	}

	departmentInfo(onComponentMount = true){ //method that grabs settings (price threshold and approval) that asm_regional has set for their region
		const action = this.props.userInfo.userType === 'asm_regional'?'regional_budget_settings':'admin_budget_settings';
		//const action = 'admin_budget_settings';
		axios({
			method:'post',
			url:path,headers:{'Content-Type':'application/json'},
			data:{endpoint:'info',table:'department',action:action,userID:this.props.userInfo.userID}
		}).then((response)=>{
			let data = response.data.data;
			let members = [];
			let membersCopy = [];
			let memberNames = [];
			let departmentNames = [];
			let initial_budget;
			if(data !== undefined && data[0] !== undefined){
				data.forEach(member=>{
					if(departmentNames.indexOf(member.department) < 0){
						departmentNames.push(member.department);
					}
					if(member.userID !== this.props.userInfo.userID && memberNames.indexOf(member.name) < 0 && member.department !== 'RSD'){
						members.push(member);
						initial_budget = member.user_type === 'asm'?(member.budget+member.spent):(member.dept_budget + member.additional_alloc);
						membersCopy.push({name:member.name,userID:member.userID,budget:member.budget,spent:member.spent,userType:member.user_type,dept_budget:member.dept_budget,additional_alloc:member.additional_alloc,initial_budget:initial_budget});
						memberNames.push(member.name);
					}else if(member.userID === this.props.userInfo.userID){
						let NSD = false;
						if((member.department === "MSM" || member.department === "RSD") && member.managerID === this.props.userInfo.userID){
							NSD = true;
							this.getAnnualBudgets();
						}
						let amtAllocated = member.dept_budget - member.spent - member.budget + member.additional_alloc;
						this.setState({initialBudget:member.dept_budget,remainingBudget:member.budget,spent:member.spent,initialAllocated:amtAllocated,allocated:amtAllocated,NSD:NSD});
					}
				});
				this.setState({departmentInfo:members,updateInfo:membersCopy,departmentNames:departmentNames},function(){
					if(this.props.userInfo.userType !== 'asm_regional' && onComponentMount){
						this.handleSelection("department",departmentNames[0]);
						this.getAnnualBudgets();
					}else{
						this.handleSelection("department",this.state.department);
						this.getAnnualBudgets();
					}
				});
			}
		});
	}

	openModal(){ //method for opening the modal
		this.setState({modalIsOpen:true});
	}

	closeModal(){ //method for closing the modal
		this.setState({modalIsOpen:false,saved:false,modalPrompt:'',modalView:'departments'});
	}

	handleSelection(identity,value){ //standard method for updating the state based on user input
		const theState = {};
		theState[identity] = value;
		if(identity === "department"){
			let currentUpdateInfo = []; //information that will actually be manipulated
			let currentDepartmentInfo = []; //information with inital values to compare new information against
			let currentAnnualUpdateInfo = [];
			if(value === "RSD"){
				this.state.departmentInfo.forEach((member)=>{
					if(member.user_type === "asm_regional"){
						if((member.userID === member.managerID) && (member.department === "RSD" || member.department === "MSM")){
							let amtAllocated = member.dept_budget - member.spent - member.budget + member.additional_alloc;
							theState['remainingBudget'] = member.budget;
							theState['initialBudget'] = member.dept_budget;
							theState['spent'] = member.spent;
							theState['initialAllocated'] = amtAllocated;
							theState['allocated'] = amtAllocated;
							theState['regionalID'] = member.managerID;
						}else{
							currentUpdateInfo.push({name:member.name,userID:member.userID,budget:member.budget,spent:member.spent,userType:member.user_type,dept_budget:member.dept_budget,additional_alloc:member.additional_alloc});
							currentDepartmentInfo.push({name:member.name,userID:member.userID,budget:member.budget,spent:member.spent,userType:member.user_type,dept_budget:member.dept_budget,additional_alloc:member.additional_alloc});
							currentAnnualUpdateInfo.push({name:member.name,userID:member.userID,budget:member.budget,spent:member.spent,userType:member.user_type,dept_budget:member.dept_budget,additional_alloc:member.additional_alloc});
						}
					}
				});
			}else{
				this.state.departmentInfo.forEach((member)=>{

					if(member.department === value){
						if(member.user_type !== "asm_regional"){
							currentUpdateInfo.push({name:member.name,userID:member.userID,budget:member.budget,spent:member.spent,userType:member.user_type,dept_budget:member.dept_budget,additional_alloc:member.additional_alloc});
							currentDepartmentInfo.push({name:member.name,userID:member.userID,budget:member.budget,spent:member.spent,userType:member.user_type,dept_budget:member.dept_budget,additional_alloc:member.additional_alloc});
							currentAnnualUpdateInfo.push({name:member.name,userID:member.userID,budget:member.budget,spent:member.spent,userType:member.user_type,dept_budget:member.dept_budget,additional_alloc:member.additional_alloc});
						}else{
							let amtAllocated = member.dept_budget - member.spent - member.budget + member.additional_alloc;
							theState['remainingBudget'] = member.budget;
							theState['initialBudget'] = member.dept_budget;
							theState['spent'] = member.spent;
							theState['initialAllocated'] = amtAllocated;
							theState['allocated'] = amtAllocated;
							theState['regionalID'] = member.managerID;
						}
					}
				});
			}
			theState['updateInfo'] = currentUpdateInfo;
			theState['currentDepartmentInfo'] = currentDepartmentInfo;
			theState['individualAnnualBudgetUpdate'] = currentAnnualUpdateInfo;
		}
		this.setState(theState);
	}

	handleBudget(identity,value){ //method that handles updating asm budget in the state
		const {updateInfo,departmentInfo,currentDepartmentInfo,initialBudget,initialAllocated,remainingBudget,spent} = this.state;
		//value = Number(value);
		if(value !== ''){
			value = Number(value);
		}
		updateInfo[identity].budget = value;
		//if(/^(\s*|[1-9][0-9]*)$/.test(value)){
			//value = Number(value);
			if(Number(remainingBudget) > -1){
				const department = this.props.userInfo.userType === 'asm_regional'?departmentInfo:currentDepartmentInfo;
				//value === ''?0:value;
				//updateInfo[identity].budget = department[identity].budget + value;
				//updateInfo[identity].budget = value;
				let allocated = initialAllocated;
				for(let i=0;i<updateInfo.length;i++){
					allocated += (updateInfo[i].budget - department[i].budget);
				}
				let remaining = initialBudget - spent - allocated;
				if(remaining >= 0){
					this.setState({updateInfo:updateInfo,remainingBudget:remaining,allocated:allocated});
					//document.getElementById((identity+"_budget")).style.borderColor = "inherit";
				}else{
					//document.getElementById((identity+"_budget")).style.borderColor = "red";
					document.getElementById((identity+"_budget")).value = Number(value.toString().slice(0,-1));
				}
			}else{
				document.getElementById((identity+"_budget")).value = '';
			}
		// }else{
		// 	document.getElementById((identity+"_budget")).value = '';
		// }
	}

	onSave(){ //method for updating user budgets in database
		this.setState({loading:true,modalIsOpen:true});
		let budgetChanges = [];
		let inputsToClear = [];
		const {updateInfo,departmentInfo} = this.state;
		const secondID = this.props.userInfo.userType !== 'asm_regional'?this.state.regionalID:this.props.userInfo.userID;
		for(let i=0;i<updateInfo.length;i++){
			if(updateInfo[i].budget !== departmentInfo[i].budget){
				inputsToClear.push(i+"_budget");
				budgetChanges.push(
					axios({
						method:'post',
						url:path,
						data:{endpoint:'create',table:'points',misc:'budget',firstID:updateInfo[i].userID,cost:updateInfo[i].budget,secondID:secondID}
					})
				);
			}
		}
		let prompt;
		if(inputsToClear.length < 1){
			prompt = 'No new information was entered';
		}
		axios.all(budgetChanges).then(response=>{
			for(let j=0;j<inputsToClear.length;j++){
				document.getElementById(inputsToClear[j]).value = '';
			}
			this.departmentInfo(false);
			prompt = 'Budgets successfully updated';
			this.setState({loading:false,modalPrompt:prompt});
		}).catch((error)=>{
			prompt = 'There was a problem updating the budgets';
			this.setState({loading:false,modalPrompt:prompt});
		});
		
	}

	getAnnualBudgets(){
		axios({
			method:'post',
			url:path,
			data:{endpoint:'info',table:'budgets'}
		}).then((response)=>{
			let data = response.data.data;
			let budgetsOne = [];
			let budgetsTwo = [];
			data.forEach((department)=>{
				budgetsOne.push(department);
				budgetsTwo.push({deptID:department.deptID,asm_budget:department.asm_budget,rsd_budget:department.rsd_budget,department:department.department});
			});
			this.setState({annualBudgetInfo:budgetsOne,annualBudgetUpdate:budgetsTwo});
		});
	}

	setAnnualBudgets(){
		this.setState({loading:true});
		let update;
		let prompt;
		//let current = this.state.annualBudgetInfo;
		let budgetUpdates = [];
		if(this.state.modalView === 'departments'){
			update = this.state.annualBudgetUpdate;
			for(let i = 0; i < update.length; i++){
				if(update[i].asm_budget > 0 || update[i].rsd_budget > 0){
					budgetUpdates.push(
						axios({
							method:'post',
							url:path,
							data:{endpoint:'create',table:'budget',firstID:update[i].deptID,cost:update[i].asm_budget,costTwo:update[i].rsd_budget,name:update[i].department}
						})
					);
					// if(update[i].department !== "RSD"){
					// 	document.getElementById(i+"_asm").value = '';
					// 	document.getElementById(i+"_rsd").value = '';
					// }else{
					// 	document.getElementById(i+"_rsd").value = '';
					// }
				}
			}
		}else{
			update = this.state.individualAnnualBudgetUpdate;
			for(let i = 0; i < update.length; i++){
				if(update[i].budget !== '' && update[i].budget !== this.state.updateInfo[i].budget){
					budgetUpdates.push(
						axios({
							method:'post',
							url:path,
							data:{endpoint:'create',table:'points',misc:'individual_annual',cost:update[i].budget,firstID:update[i].userID}
						})
					);
				}
			}
		}

		if(budgetUpdates.length > 0){
			axios.all(budgetUpdates).then((response)=>{
				prompt = 'Annual budgets set';
				this.setState({loading:false,modalPrompt:prompt});
				this.departmentInfo(false);
			}).catch((error)=>{
				prompt = 'There was a problem updating the annual budgets';
				this.setState({loading:false,modalPrompt:prompt});
			});
		}else{
			prompt = 'No budget info was entered.';
			this.setState({loading:false,modalPrompt:prompt});
		}
	
	}

	handleAnnualBudget(identity,value){
		if(/^(\s*|[1-9][0-9]*)$/.test(value)){
			let info = identity.split("_");
			let index = Number(info[0]);
			let theState = this.state.annualBudgetUpdate;
			value = (value === '')?value:Number(value);
			if(info[1] === 'rsd'){
				theState[index].rsd_budget = value;
			}else{
				theState[index].asm_budget = value;
			}
			this.setState({annualBudgetUpdate:theState});
		}else{
			document.getElementById(identity).value = '';
		}
	}

	individualAnnualBudget(identity,value){
		if(/^(\s*|[1-9][0-9]*)$/.test(value)){
			let info = identity.split("_");
			let index = Number(info[0]);
			let theState = this.state.individualAnnualBudgetUpdate;
			if(value !== ''){
				value = Number(value);
			}
			theState[index].budget = value;
			this.setState({individualAnnualBudgetUpdate:theState});
		}else{
			document.getElementById(identity).value = '';
		}
	}

	hoverTab(e){
		if(e.target.id === 'hoverTabOne'){
			document.getElementById(e.target.id).classList.remove("hoverTab");
			document.getElementById("hoverTabTwo").classList.add("hoverTab");
			document.getElementById("hoverTabTwo").classList.remove("hoverTabClicked");
			document.getElementById(e.target.id).classList.add("hoverTabClicked");
			this.setState({modalView:'departments'});
		}else{
			document.getElementById(e.target.id).classList.remove("hoverTab");
			document.getElementById("hoverTabOne").classList.add("hoverTab");
			document.getElementById("hoverTabOne").classList.remove("hoverTabClicked");
			document.getElementById(e.target.id).classList.add("hoverTabClicked");
			this.setState({modalView:'individuals'});
		}		
	}

	render(){
		let customStyles = {
		  content : {
		    top: '50%',
		    left: '50%',
		    right: 'auto',
		    bottom: 'auto',
		    width:'100%',
		    maxWidth:'700px',
		    minWidth:'320px',
		    height:'auto',
		    maxHeight:'530px',
		    padding:'10px',
		    transform: 'translate(-50%, -50%)',
		    boxShadow:'0.5px 0.5px 1px 0.5px',
		    backgroundColor:'#f1f1f1'
			}, 
			overlay:{
				backgroundColor:'rgba(105,105,105,0.8)'
			}
		};
		if(this.state.modalPrompt === '' && !this.state.loading){
			customStyles.height = '530px';
		}
		let content;
		const buttonstyle = "dim pb2 mt2 pt2 b white w-100 center bg-dark-blue br2 shadow-2";
		const buttonstyleTwo = "dim pb2 mt2 pt2 b white w-100 center bg-dark-blue br2 shadow-2";
		const selectStyle = "h2 pa1 br2 bw1 w-100 truncate shadow-2";
		const inputStyle = "h2 br2 bw1 shadow-3 w-100 pl2 pr2";
		let mainDivStyle ={
								boxShadow:'0px 0px 5px 5px #aaaaaa inset',
								backgroundColor:'white',
								minWidth:'300px',
								margin:'auto',
								maxHeight:'580px',
								height:'580px',
								width:'90%',
								maxWidth:'800px'
							};
		let memberUlDivStyle = {maxHeight:'300px'};
		let memberUlStyle = {maxHeight:'290px'};
		let memberUlDivClassName = "fl w-100 overflow-y-auto bb b--gray pb1 mb3";
		//let totalAllocated = 0;
		let modalContent;
		let spent;
		let id;
		let button;
		let departmentMemberInputs = this.state.updateInfo.map((members,i)=>{ //loop through asms and create input fields
		//totalAllocated += Number(this.state.departmentMembers[i].budget);
		id = i+"_budget";
		spent = members.userType === 'asm'?members.spent:(members.dept_budget - members.budget);
		let totalBudget = spent + members.budget;
		let input_val; //= (members.budget === null || members.budget === undefined || members.budget === '')?'':members.budget.toFixed(2);

		if(members.budget === null || members.budget === undefined){
			input_val = 0.00;
		}else if(members.budget !== ''){
			input_val = Number(members.budget.toFixed(2));
		}
		return (
			
				<li className="mb2 mt0 fl w-100" key={i}>
					<div className="fl w-33 center pa0 pt2">
						<div className = "mt1 tl">
							<p className="navy b pa0 ma0">{members.name} </p>
						</div>
					</div>
					<div className="fl w-33 pa0 pt2 tl">
						<div>
							<p className="navy pa0 ma0">${totalBudget}</p>
						</div>
					</div>
					<div className="fl w-33 pa0">
						<div className="pr2">
							<Input name="budget" id={id} identity={i} onInput={this.handleBudget} inputStyle={inputStyle} placeholder="0" val={input_val}/>
						</div>
					</div>
				</li>
			);
	});
		if(this.state.NSD){
			button = <div className="fl w-50 pt1 pl2">
						<button onClick={this.openModal} className="dim h2 ml2 mt3 b white w-100 center bg-navy br2 shadow-2">Annual Budgets</button>
					</div>;
		}
		let asmRegionalBudgetInfo = <div className="fl w-100">
										<div className="fl w-100">
											<div className="fl w-100">
												<p className="f5 ma0 pt2"><span className="b navy">Initial Budget:</span> ${this.state.initialBudget}</p>
											</div>
											<div  className="fl w-100">
												<p className="f5 ma0 pt2"><span className="b navy">Remaining Budget:</span> ${this.state.remainingBudget}</p>
											</div>
										</div>
										<div className="fl w-30">
											<div  className="fl w-100">
												<p className="f5 ma0 pt2"><span className="b navy">Amount Spent:</span> ${this.state.spent}</p>
											</div>
											<div  className="fl w-100">
												<p className="f5 ma0 pt2"><span className="b navy">Amount Allocated:</span> ${this.state.allocated}</p>
											</div>
										</div>
										<div  className="fl w-50">
											{button}
										</div>
									</div>;
		if(this.props.userInfo.userType !== 'asm_regional'){
			memberUlDivStyle.maxHeight = '230px';
			if(this.props.userInfo.userType === 'asm_admin' || this.props.userInfo.userType === 'sys_admin'){
				mainDivStyle.boxShadow = '';
				mainDivStyle.backgroundColor = '';
				mainDivStyle.height = 'inherit';
				mainDivStyle.maxHeight = 'inherit';
				memberUlDivStyle.maxHeight = '';
				memberUlStyle.maxHeight = '';
				memberUlDivClassName = "fl w-100 bb b--gray pb1"
			}
			asmRegionalBudgetInfo = <div className="fl w-100">
										<div className="fl w-100">
											<div className="fl w-100">
												<div className="fl w-50">
													<div className="pb1">
														<label className="navy b">Region/Department: </label>
													</div>
													<SelectBox name="department" identity="department" onSelect={this.handleSelection} options={this.state.departmentNames} styles={selectStyle} val={this.state.department}/>
												</div>
												<div className="fl w-25 pt1 pl2">
													<button onClick={this.openModal} className="dim h2 ml2 mt3 b white w-100 center bg-navy br2 shadow-2">Annual Budgets</button>
												</div>
											</div>
											<div  className="fl w-100 mt2 pb2 pt2">
												<div className="fl w-100">
													<div className="fl w-100">
														<p className="f5 ma0 pt2"><span className="b navy">Initial Budget:</span> ${this.state.initialBudget.toFixed(2)}</p>
													</div>
													<div  className="fl w-100">
														<p className="f5 ma0 pt2"><span className="b navy">Remaining Budget:</span> ${this.state.remainingBudget.toFixed(2)}</p>
													</div>
												</div>
												<div className="fl w-100">
													<div  className="fl w-100">
														<p className="f5 ma0 pt2"><span className="b navy">Amount Spent:</span> ${this.state.spent.toFixed(2)}</p>
													</div>
													<div  className="fl w-100">
														<p className="f5 ma0 pt2"><span className="b navy">Amount Allocated:</span>${this.state.allocated.toFixed(2)}</p>
													</div>
												</div>
											</div>
										</div>
									</div>;
			}
			if(this.props.userInfo.userType !== 'asm_regional' || this.state.NSD){
				let theinputs;
				if(this.state.modalView === 'departments'){
					theinputs = this.state.annualBudgetUpdate.map((department,i)=>{
						let asm = i+"_asm";
						let rsd = i+"_rsd";
						let inputs;
							if(department.department !== "RSD" && department.department !== "MSM"){
								inputs =<li key={i} className="fl w-100">
											<div className="fl w-33 tc pa2">
												<p className="navy b pa0 ma0">{department.department}</p>
											</div>
											<div className="fl w-33 pa2">
												<Input name="rsd_budget"  identity={rsd} id={rsd} onInput={this.handleAnnualBudget} inputStyle={inputStyle} val={department.rsd_budget}/>
											</div>
											<div className="fl w-33 pa2">
												<Input name="asm_budget"  identity={asm} id={asm} onInput={this.handleAnnualBudget} inputStyle={inputStyle} val={department.asm_budget}/>
											</div>
										</li>;
							}else{
								if(department.department === "RSD"){
									inputs =<li key={i} className="fl w-100">
												<div className="fl w-33 tc pa2">
													<p className="navy b pa0 ma0">{department.department}</p>
												</div>
												<div className="fl w-33 pa2">
													<Input name="rsd_budget"  identity={rsd} id={rsd} onInput={this.handleAnnualBudget} inputStyle={inputStyle} val={department.rsd_budget}/>
												</div>
												<div className="fl w-33 tc pt2">
													<p className="navy b pa0 ma0 pt2">N/A</p>
												</div>
											</li>;
								}else{
									inputs =<li key={i} className="fl w-100">
												<div className="fl w-33 tc pa2">
													<p className="navy b pa0 ma0">{department.department}</p>
												</div>
												<div className="fl w-33 tc pt2">
													<p className="navy b pa0 ma0 pt2">N/A</p>
												</div>
												<div className="fl w-33 pa2">
													<Input name="asm_budget"  identity={asm} id={asm} onInput={this.handleAnnualBudget} inputStyle={inputStyle} val={department.asm_budget}/>
												</div>
											</li>;
								}
							}
					
						return inputs;
					});
				}else{
					theinputs = this.state.individualAnnualBudgetUpdate.map((asminfo,i)=>{
						let annualBudget = '';
						//if(asminfo.department === this.state.department){
							if(asminfo.budget !== ''){
								annualBudget = Number(asminfo.budget + asminfo.spent);
							}else{
								asminfo.budget = 0;
							}
							return (
								<li key={i} className="fl w-100">
									<div className="fl w-33 tc pa2">
										<p className="navy b pa0 ma0">{asminfo.name}</p>
									</div>
									<div className="fl w-33 tc pt2">
										<p className="navy b pa0 ma0 pt2">{asminfo.budget.toFixed(2)}</p>
									</div>
									<div className="fl w-33 pa2">
										<Input name="asm_budget"  identity={i+"_asmbudget"} id={i+"_asmbudget"} onInput={this.individualAnnualBudget} inputStyle={inputStyle} val={annualBudget}/>
									</div>
								</li>
							);		
						//}
					});
				}
				let budgetHeaders,departmentSelect;
				let inputsDivStyle = {};
				if(this.state.modalView === "departments"){
					budgetHeaders = <li className="fl w-100 tc">
										<div className="fl w-33">
											<p className="navy b pa0 ma0">Department</p>
										</div>
										<div className="fl w-33">
											<p className="navy b pa0 ma0">Regional</p>
										</div>
										<div className="fl w-33">
											<p className="navy b pa0 ma0">ASM</p>
										</div>
									</li>;
				}else{
					inputsDivStyle = {maxHeight:'273px'};
					departmentSelect = <div className="fl w-100 pt3"><SelectBox name="department" identity="department" onSelect={this.handleSelection} options={this.state.departmentNames} styles={selectStyle} val={this.state.department}/></div>;
					budgetHeaders = <li className="fl w-100 tc">
										<div className="fl w-33">
											<p className="navy b pa0 ma0">Name</p>
										</div>
										<div className="fl w-33">
											<p className="navy b pa0 ma0">Remaining Budget</p>
										</div>
										<div className="fl w-33">
											<p className="navy b pa0 ma0">Annual Budget</p>
										</div>
									</li>;
				}
					modalContent = <div className="br3" style={{backgroundColor:'#f1f1f1'}}><div className="fl w-100 bb b--gray">
											<div className="w-50" style={{maxWidth:'340px',margin:'auto'}}>
												<div id="hoverTabOne" className="fl w-50 f3 tc pt2 pb2 hoverTabClicked" onClick={this.hoverTab}>Departments</div>
												<div id="hoverTabTwo" className="fl w-50 f3 tc pt2 pb2 hoverTab" onClick={this.hoverTab}>Individuals</div>
												{departmentSelect}
											</div>
									        <ul className="fl w-100 list mb1 pl2 pt3">
									        	{budgetHeaders}
									        </ul>
									     </div>
									    <div style={inputsDivStyle} className="fl w-100 bb b--gray mb2 overflow-y-auto">
									        <ul className="fl list w-100 pl2">
									        	{theinputs}
									        </ul>
									    </div>
								        <div className="pa2 mt3 w-30 center " style={{minWidth:'180px'}}>
								        	<button onClick={this.setAnnualBudgets} className={buttonstyle}>Set Budgets</button>
								        </div></div>;
			}
			
		if(this.state.loading && this.state.modalPrompt === ''){
			modalContent = <div className="tc" style={{width:'150px',margin:'auto'}}><img src={loader} alt="Loading" /></div>;
		}else if(!this.state.loading && this.state.modalPrompt !== ''){
			modalContent = <div className = "w-100 tc"><p className="navy b f3">{this.state.modalPrompt}</p></div>;
		}

		if(this.props.active){
			content = <div style={mainDivStyle} className="br3 pa3">
									<div className="fl w-100 mb2 pb2 " style={{maxHeight:'450px'}}>
										{asmRegionalBudgetInfo}
										<div className="fl w-100 bb b--gray">
											<ul className="fl w-100 list mb1 pl2">
												<li className="fl w-100" style={{paddingRight:'18px'}}>
													<div className="fl w-33">
														<p className="ma0 pa0 b">Team Member</p>
													</div>
													<div className="fl w-33">
														<p className="ma0 pa0 b">Budget</p>
													</div>
													<div className="fl w-33">
														<p className="ma0 pa0 b">Remaining</p>
													</div>
												</li>
											</ul>
										</div>
										<div className={memberUlDivClassName} style={memberUlDivStyle}>
											<ul className="fl list w-100 pl2" style={memberUlStyle}>
												{departmentMemberInputs}
											</ul>
										</div>
										<div className="fl w-100 mt3 mb3 pb4">
											<div className="w-100 center tc" style={{maxWidth:'220px',marginLeft:'auto',marginRight:'auto'}}>
												<button onClick={this.onSave} className={buttonstyleTwo}>Update</button>
											</div>
										</div>
									</div>
									
									<div>
										<Modal
							          isOpen={this.state.modalIsOpen}
							          style={customStyles}
							          contentLabel="confirmation"
							          shouldCloseOnOverlayClick={false}
							          shouldCloseOnEsc={false}
							        >
							        <div className="fl w-100 tr">
							        	<button className="b br3" style={{backgroundColor:'#f1f1f1'}} onClick={this.closeModal}>X</button>
							        </div>
							        {modalContent}
							      </Modal>
									</div>
									</div>;
		}
		return(
			<div>
			{content}
			</div>
		);
	}
}

// content = <div>
// 									<div className="w-100 center">
// 										<div className="w-100 tc">
// 											<button className="br2 h3 shadow-3 br3 pt1 pb1" onClick={this.openModal} style={buttonStyles}><span className="navy b" style={{marginLeft:'65px',marginRight:'10px'}}>Notification Settings</span></button>
// 										</div>
// 									</div>
// 									<div className="fl w-100 mt3">
// 										<ViewASMOrders userInfo={this.props.userInfo} app={this.props.app} view="regional" approval={this.state.current} active={true} logChange={this.props.logChange}/>
// 									</div>
									
// 								</div>;

// <div>
// 	<p className="f5"><span className="b navy">Total Budget For {this.state.region}:</span> ${this.state.regionBudget}</p>
// </div>

// <div className="pa2">
// 							        	<div>
// 							        		<label className="navy b pb3">RSD Annual Budget: </label>
// 							        	</div>
// 							        	<div>
// 							        		<Input name="RSD_yearly_budget" id="rsd_yearly_budget" identity="rsd_yearly_budget" onInput={this.handleAnnualBudget} inputStyle={inputStyle} type="number" placeholder="0"/>
// 							        	</div>
// 							        </div>
// 							        <div className="pa2">
// 							        	<div>
// 							        		<label className="navy b pb3">ASM/MSM Annual Budget: </label>
// 							        	</div>
// 							        	<div>
// 							        		<Input name="ASM_yearly_budget" id="asm_yearly_budget" identity="asm_yearly_budget" onInput={this.handleAnnualBudget} inputStyle={inputStyle} type="number" placeholder="0"/>
// 							        	</div>
// 							        </div>

// <div className="fl w-30">
// 														<p className="ma0 pa0 b">Team Member</p>
// 													</div>
// 													<div className="fl w-25">
// 														<p className="ma0 pa0 b">Total Spent</p>
// 													</div>
// 													<div className="fl w-25">
// 														<p className="ma0 pa0 b">Remaining Budget</p>
// 													</div>
// 													<div className="fl w-20">
// 														<p className="ma0 pa0 b">Amt. to Allocate</p>
// 													</div>

// <div className="fl w-25 pa0 pt2 tl">
// 						<div>
// 							<p className="navy pa0 ma0">${members.budget}</p>
// 						</div>
// 					</div>


// WEBPACK FOOTER //
// ./src/container/ASMRegionalCenter.js